import ConversionFunnelChart from '@/modules/Report/components/SalePerformances/components/ConversionFunnelChart'
import { CustomerPipelineFilters } from '@/modules/Report/components/SalePerformances/types'
import dayjs from 'dayjs'
import { useMemo } from 'react'

const ConversionFunnelWidget: React.FC = () => {
    const today = dayjs()
    const filters: CustomerPipelineFilters = useMemo(
        () => ({
            gte: today.subtract(30, 'day').format('YYYY-MM-DD'),
            lte: today.format('YYYY-MM-DD'),
        }),
        []
    )

    return (
        <div className="h-full">
            <ConversionFunnelChart
                filters={filters}
                enabledConversionRates={false}
            />
        </div>
    )
}

export default ConversionFunnelWidget
